import type { AutoCompleteItem } from '/react4xp/components/react-hook-form/AutoCompleteItem.d';
import type { Phrases } from '../../common/Phrases.d';

import React, { useEffect, useId, useMemo, useRef } from 'react';
import { Row } from '/react4xp/components/Flex';
import { Fieldset } from '/react4xp/components/react-hook-form/Fieldset';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { sanitizeHtml } from '/react4xp/shared/sanitizeHtml';
import { WhereAutoComplete } from './WhereAutoComplete';
import { WhereOtherButton } from './WhereOtherButton';
import { WhereOtherTextField } from './WhereOtherTextField';
import {
	WHERE_LEGEND_ID,
} from '../../common/constants';
import {
	ANONYMOUS_FIELD_NAME,
	ANONYMOUS_WHERE,
} from '../constants';


export const WhereFieldset = ({
	label,
	municipalityOptions,
	phrases,
}: {
	label: string;
	municipalityOptions: AutoCompleteItem<string>[];
	phrases: Phrases;
}): React.JSX.Element => {
	const description = phrases['notificationForm.anonymous.whereField.description'];

	const descriptionId = useId();
	const scrollRef = useRef();

	const {
		setScrollRef,
	} = useFormContext();

	const whereOptions: AutoCompleteItem<string>[] = useMemo(() => ([] as AutoCompleteItem<string>[]).concat(
		{
			id:	ANONYMOUS_WHERE.INTERNET,
			label: sanitizeHtml(phrases['notificationForm.anonymous.whereField.value.internet']),
		},
		municipalityOptions,
		{
			id: ANONYMOUS_WHERE.OTHER,
			label: sanitizeHtml(phrases['notificationForm.anonymous.whereField.value.other']),
		},
	), [phrases]);

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: ANONYMOUS_FIELD_NAME.WHERE, el: scrollRef.current });
			setScrollRef({ field: ANONYMOUS_FIELD_NAME.WHERE_OTHER, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			legend={label}
			legendId={WHERE_LEGEND_ID}
			legendRef={scrollRef}
			name={ANONYMOUS_FIELD_NAME.WHERE}
			required
		>
			<span className='font-normal text-sm' id={descriptionId}>{description}</span>
			<Row className='gap-sm'>
				<WhereAutoComplete
					descriptionId={descriptionId}
					errorSummaryLabel={label}
					items={whereOptions}
					phrases={phrases}
				/>
				<WhereOtherButton phrases={phrases}/>
			</Row>
			<WhereOtherTextField phrases={phrases} whereLabel={label}/>
		</Fieldset>
	);
};
